import DropDown from '@/components/theme/Dropdown.vue'

export default {
    components: {
        DropDown
    }
}



// WEBPACK FOOTER //
// ./src/components/user/dashboard/mobile/mobile.js